import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    languageActiveId: 1,
    logoBrand: null,
    allFirstFlowList: [{ mainIntentId: 0, intentName: "Please Select" }],
    symbolList: [
      {
        id: 0,
        name: "Please Select",
        isRequired: true,
        type: ["Number", "String"],
      },
    ],
    symbolStringList: [
      {
        id: 0,
        name: "Please Select",
        isRequired: true,
        type: ["Number", "String"],
      },
    ],
    symbolNumberList: [
      {
        id: 0,
        name: "Please Select",
        isRequired: true,
        type: ["Number", "String"],
      },
    ],
    variableList: [{ id: 0, name: "Please Select", type: "String" }],
    variableStringList: [{ id: 0, name: "Please Select" }],
    variableNumberList: [{ id: 0, name: "Please Select" }],
    replyTypeList: [],
    intentTypeList: [],
    apiConfigList: [{ id: 0, name: "Please Select" }],
    tierMasterdataList: [{ id: 0, name: "Please Select", brandId: 0 }],
  },
  actions,
  getters,
  mutations,
};
